import { PlotDtoSchema } from "@farm/data/dto/plot.dto";
import * as z from "zod";

export const FarmResumeDtoSchema = z.object({
    id: z.number(),
    name: z.string().trim(),
});
export type FarmResumeDto = z.output<typeof FarmResumeDtoSchema>;

export const FarmsDtoSchema = z.array(FarmResumeDtoSchema).readonly();
export type FarmsDto = z.output<typeof FarmsDtoSchema>;

/** === Detalle de Farm === */

const FarmUserDtoSchema = z
    .object({
        id: z.number(),
        email: z.email(),
    })
    .readonly();

export const FarmDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
        enabled_satellites: z.array(z.string().trim()),
        parcels: z.array(PlotDtoSchema),
        users: z.array(FarmUserDtoSchema),
    })
    .readonly();
export type FarmDto = z.output<typeof FarmDtoSchema>;

export interface FarmCreateBody {
    farm: {
        name: string;
        enabled_satellites: string[];
        user_ids: number[];
    };
}
export interface FarmUpdateBody {
    farm: {
        name: string;
        enabled_satellites: string[];
        user_ids: number[];
    };
}
